import { Users } from "lucide-react";
import {
  Create,
  Datagrid,
  Edit,
  EmailField,
  List,
  SimpleForm,
  TextField,
  TextInput,
  useNotify,
  useRedirect,
  useRefresh,
} from "react-admin";
import { CardListActions, DefaultBulkActionButtons, EditorToolbar } from "../../components";

function renderEditForm() {
  return (
    <SimpleForm toolbar={<EditorToolbar showDelete />}>
      <TextInput source="email" label="Email" type="email" />
      <TextInput source="name" label="Name" />
    </SimpleForm>
  );
}

function CreateView(props) {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  return (
    <Create
      {...props}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify("Attendee created successfully!", {
            type: "success",
          });
          refresh();
          redirect("list", "shabbaton-2026-attendees");
        },
        onError: (error) => {
          notify(`Error: ${error.message}`, { type: "error" });
        },
      }}
    >
      {renderEditForm()}
    </Create>
  );
}

function EditView(props) {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  return (
    <Edit
      {...props}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify("Attendee updated successfully!", {
            type: "success",
          });
          refresh();
          redirect(false);
        },
        onError: (error) => {
          notify(`Error: ${error.message}`, { type: "error" });
        },
      }}
    >
      {renderEditForm()}
    </Edit>
  );
}

function ListView(props) {
  return (
    <List
      {...props}
      actions={<CardListActions exporter={true} />}
      filters={[
        <TextInput source="id" alwaysOn />,
        <TextInput label="Email" source="email" alwaysOn />,
        <TextInput label="Name" source="name" alwaysOn />,
      ]}
      perPage={25}
      sort={{ field: "id", order: "DESC" }}
      title="Shabbaton 2026 Attendees"
    >
      <Datagrid rowClick="edit" bulkActionButtons={<DefaultBulkActionButtons />}>
        <TextField source="id" label="Id" />
        <EmailField source="email" label="Email" />
        <TextField source="name" label="Name" />
      </Datagrid>
    </List>
  );
}

export const Shabbaton2026Attendees = {
  category: "misc",
  name: "shabbaton-2026-attendees",
  create: CreateView,
  edit: EditView,
  icon: Users,
  list: ListView,
  options: { label: "Shabbaton 2026 Attendees" },
};
